{
	"page": {
		"title": "Registration Windows",
		"intro": "When organisations may register people for each category. Outside every window the category reads “Registration closed” for them. Admins can always register.",
		"add": "Add window",
		"count_one": "{{n}} window",
		"count_other": "{{n}} windows"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} window",
		"summary_other": "{{from}}–{{to}} of {{total}} windows",
		"empty": "No windows"
	},
	"filters": {
		"games": "Games",
		"category": "Category",
		"organisation": "Organisation",
		"search": "Search"
	},
	"table": {
		"category": "Category",
		"games": "Games",
		"organisation": "Organisation",
		"allOrganisations": "All organisations",
		"opens": "Opens",
		"closes": "Closes",
		"status": "Status",
		"editLabel": "Edit the window for {{name}}",
		"deleteLabel": "Delete the window for {{name}}"
	},
	"status": {
		"open": "Open now",
		"upcoming": "Upcoming",
		"closed": "Closed"
	},
	"empty": {
		"filteredTitle": "No windows match these filters",
		"filteredDescription": "Try another games, category or organisation, or clear the filters.",
		"noneTitle": "No registration windows yet",
		"noneDescription": "Until a window is open, organisations can't register anyone. Add one per category.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add registration window",
		"editTitle": "Edit registration window",
		"description": "Organisations can register people of this category while the window is open.",
		"games": "Games",
		"gamesPlaceholder": "Select games",
		"gamesFixed": "The games of a window can't change. Delete it and add a new one instead.",
		"category": "Category",
		"categoryPlaceholder": "Select a category",
		"organisation": "Organisation",
		"organisationHint": "Leave empty to open the category for every organisation.",
		"allOrganisations": "All organisations",
		"opensAt": "Opens at",
		"closesAt": "Closes at",
		"zoneHint": "Times are in your time zone ({{zone}}).",
		"required": "Required",
		"closesAfterOpens": "Must be after the opening time",
		"add": "Add window",
		"save": "Save changes"
	},
	"toast": {
		"added": "Registration window added",
		"updated": "Registration window updated",
		"addFailed": "Couldn't add the window",
		"updateFailed": "Couldn't update the window"
	},
	"delete": {
		"title": "Delete registration window",
		"description": "Delete the <strong>{{category}}</strong> window for {{games}}? Organisations it covers can't register this category until another window opens.",
		"confirm": "Delete window",
		"deleted": "Registration window deleted.",
		"failed": "Couldn't delete the window"
	}
}
